<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">


       <el-row :span="2" style="margin-top: 30px;">
           <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>
       
           <el-button type="primary" style="background-color: #409eff;" @click="loadList()" round>搜索</el-button>
       </el-row>
        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
			<el-table-column
			
			  width="500"
			  label="宇宙名称"
			   >
			   <template slot-scope="scope">
			       <div>{{scope.row.name}}</div>
			   </template>
			</el-table-column>
            <el-table-column

              width="500"
              label="Appid"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.appid}}</div>
               </template>
            </el-table-column>
			<el-table-column
			
			  width="200"
			  label="已选功能"
			   >
			   <template slot-scope="scope">
			     <div v-if="scope.row.onemore == 1"><el-button type="primary" style="background-color: #9240ff;" round>单功能</el-button></div>
				 <div v-if="scope.row.onemore == 2"><el-button type="primary" style="background-color: #ff4040;" round>多功能</el-button></div>
			   </template>
			</el-table-column>
            <el-table-column

              width="200"
              label="设置单功能"
               >
               <template slot-scope="scope">
                 <div><el-button type="primary" style="background-color: #409eff;" @click="reset(scope.row.id,scope.row.appid,1)" round>单功能</el-button></div>
				 
               </template>
            </el-table-column>
            <el-table-column
            
              width="200"
              label="设置多功能"
               >
               <template slot-scope="scope">
                 
            	 <div><el-button type="primary" style="background-color: #409eff;" @click="reset(scope.row.id,scope.row.appid,2)" round>多功能</el-button></div>
               </template>
            </el-table-column>

            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>


    

    
    <el-dialog
      title="修改级别"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="addT"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dochange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {

       return {
		 seachName:'',
         appid:'',
         data: [],
         value: [],
         page:1,
         count:0,
         list:[],
         addVisible:false,
         setVisible:false,
         seeVisible:false,
         glist:[],
         lists:[],
         aid:0,
         addT:'',
         id:0,
         centerDialogVisible:false,



      }
    },
  directives: {
    },
    created() {
      this.loadList();

    },

  methods:{
    reset(id,appid,type){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          appid:appid,
		  type:type
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appidOneset'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
		   this.loadList();

      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    
    
    

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appidOneList'
      })
      .then(res=>{

        this.list = res.data.data;
        this.count = res.data.count;
       


      })
      .catch(err=>{

      });
    }, 
   msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
  .el-transfer-panel__list{
    height: 800px;
  }
  .el-transfer-panel__body{
    height: 800px;
  }
  .el-transfer-panel__body{
    height: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/aone.vue